import type { Fallback, Variant } from "../types"

export const getVariantFromFallback = <TPayload>(fallback: Fallback<TPayload>): Variant<TPayload> =>
  typeof fallback === "string" ? { value: fallback, payload: undefined } : fallback
